// extracted by mini-css-extract-plugin
export default {"modal-header":"GenerateNapsaModal_modal-header__xCGIq","close-icon":"GenerateNapsaModal_close-icon__gsjnr","modal-body":"GenerateNapsaModal_modal-body__iwAkZ"};